<template>
  <modal-dialog ref="modal" :title="title">
    <slot />

    <template v-slot:footer>
      <button class="btn btn-secondary" @click.prevent="cancel">
        No
      </button>
      <button class="btn btn-primary" @click.prevent="confirm">
        Yes
      </button>
    </template>
  </modal-dialog>
</template>

<script>
  import ModalDialog from './modal-dialog'

  export default {
    components: {
      ModalDialog
    },
    props: {
      title: {
        type: String, default: 'Please confirm'
      }
    },
    methods: {
      open() {
        this.$refs.modal.open()
      },
      cancel() {
        this.$refs.modal.close()
      },
      confirm() {
        this.$emit('confirm')
      }
    }
  }
</script>
